import { render, staticRenderFns } from "./Yearpage.vue?vue&type=template&id=21edb3dc&"
import script from "./Yearpage.vue?vue&type=script&lang=js&"
export * from "./Yearpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports